import Routes from './Routes';

import * as reducer from './reducer';

const Reports = () => (
    <>
        <Routes />
    </>
);

export { Reports, reducer };
